import { Routes } from '@angular/router';
import { IsSignedInGuard } from './routes/is-signed-in-guard';
import { IsUnsignedInGuard } from './routes/is-unsigned-in-guard';
import namedRoutes from './routes/named-routes';

export const routes: Routes = [
  {
    path: namedRoutes.auth.signIn,
    loadChildren: () => import('./presentation/login/login.routes').then(mod => mod.LOGIN_ROUTES),
    canActivate: [IsUnsignedInGuard],
  },
  {
    path: namedRoutes.auth.ad,
    loadChildren: () => import('./presentation/ad-redirect/ad.routes').then(mod => mod.AD_ROUTES),
    canActivate: [IsUnsignedInGuard],
  },
  {
    path: namedRoutes.auth.adLogout,
    loadChildren: () =>
      import('./presentation/ad-redirect-logout/ad-logout.routes').then(
        mod => mod.AD_LOGOUT_ROUTES
      ),
  },
  {
    path: '',
    loadChildren: () => import('./routes/signed-routes').then(mod => mod.SIGNED_ROUTES),
    canActivate: [IsSignedInGuard],
  },
];
